export default {
  state: {
    stripe: {
      cardOwner: '',
      address: '',
      userCity: '',
      userState: '',
      userZip: '',
      userCountry: '',
    }
  },
  mutations: {
    setStripeData (state, data) {
      for (let field in data) {
        state.stripe[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation-details/stripe.js